import React, {
  useEffect,
  useMemo,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import {otpStyle} from "./OTPCompStyle";
import {CPSNumbers} from "commonUtils/enumerations";
import Typography from "@mui/material/Typography";

interface contentProps {
  length: number;
  handleOtpSent: (e: any, preferredMethod: number) => void;
  resendCountDown: number;
  lbltext: string;
  otpSentMethod: number;
  handleFocusNext: () => void;
}
const OTPComp = forwardRef(
  (
    {
      length,
      handleOtpSent,
      resendCountDown,
      lbltext,
      otpSentMethod,
      handleFocusNext,
    }: contentProps,
    ref,
  ) => {
    const [otp, setOtp] = useState(new Array(length).fill(""));
    const [countDown, setCountDown] = useState<number>(resendCountDown);
    const [onTime, setOnTime] = useState<string>('');

    const handleOnChange = (el: any, index: number) => {
      if (isNaN(el.value)) return;
      
      if (el.nextSibling && el.value) {
        setOtp([...otp.map((val, idx) => (idx === (index) ? el.value : val))]);
        el.nextSibling.focus();
      }else {
        const data = [...otp.map((val, idx) => (idx === (index) ? el.value : val))];
        setOtp(data);
        const otpData = data.join("");
        if(otpData.length === length){
          handleFocusNext();
        }
      }
    };

    const handleKeyDown = (event: any, index: number) => {
      if (event.key === "Backspace") {
        if (event.target.value === "" && event.target.previousSibling) {
          event.target.previousSibling.focus();
        }
      }
    };

    const padTime = (time: number) => {
      return String(time).length === 1 ? `0${time}` : `${time}`;
    };

    const format = (time: number) => {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      return `${padTime(minutes)}:${padTime(seconds)}`;
    };

    const focusOtp1 = () =>{
      const optin: HTMLInputElement | null =
      document.querySelector(`[tabIndex='1']`);
      if (optin) {
        optin.focus();
      }
    }
    useMemo(() => {
      setTimeout(() => {
        focusOtp1();
      }, 1000);
      setOnTime((new Date()).toString());
    }, [resendCountDown]);

    useEffect(() => {
      let timerInterval: any = null;

      timerInterval = setInterval(() => {
        var sec = resendCountDown;
        var diff = new Date().getTime() - new Date(onTime).getTime();
        let ss = Math.floor(diff / 1000) % 60;
        let mm = Math.floor(diff / 1000 / 60) % 60;
        diff = (mm * 60) + ss;
        if (Number.isInteger(sec)) {
            sec -= diff;
        }
        if (sec <= 0 || isNaN(sec)) {
            clearInterval(timerInterval);
            sec = 0;
            setOnTime("");
        }
        setCountDown(sec);
    }, 1000);

      return () => {
        if (timerInterval) {
          clearTimeout(timerInterval);
        }
      };
    }, [countDown]);

    useImperativeHandle(ref, () => ({
      verify() {
        const data = otp.join("");
        return data;
      }
    }));

    return (
      <Box sx={otpStyle.GridContainer}>
        <Box sx={otpStyle.otpInputs}>
          {otp.map((val, index) => (
            <input
              className="OtpInput"
              key={index}
              type="text"
              tabIndex={index + 1}
              maxLength={CPSNumbers.ONE.valueOf()}
              value={val}
              onChange={e => {
                handleOnChange(e.target, index);
              }}
              onKeyDown={e => {
                handleKeyDown(e, index);
              }}
            />
          ))}
        </Box>
        <Box> 
          <Typography
          component="p"
            sx={otpStyle.lbltext}>
            {lbltext}
          </Typography>
        </Box>
        <Box sx={otpStyle.InLineBox}>
          <Link
            sx={countDown > 0 ? otpStyle.GrayOut : otpStyle.BlueColor}
            component="button"
            onClick={(e: any) => {
              if(countDown === 0)
              {
                handleOtpSent(e, otpSentMethod);
              }
            }}>
            <Box sx={otpStyle.BoxSpaceResend}>{"Resend "}</Box>
          </Link>
          <Box sx={otpStyle.BoxSpace}>
            {countDown === 0 ? " 00:00" : format(countDown)}
          </Box>
        </Box>
      </Box>
    );
  },
);

OTPComp.displayName = "OTPComp";
export default OTPComp;
